/**
 * 设备检测：根据User-Agent识别
 * @author luoying<luoying@szzbmy.com>
 * @since 2018/11/07
 */
import { isMobileByUserAgent } from './is-mobile';
function parseVersion(version) {
    const vs = version.split('.');
    const major = vs.shift();
    return parseFloat(major + '.' + vs.join(''));
}
function getLinuxInfo(ua) {
    let name = 'Linux';
    let version = '';
    if (ua.match('CentOS')) {
        name = 'CentOS';
        const match = /CentOS\/[0-9.-]+el([0-9_]+)/.exec(ua);
        if (match)
            version = match[1].replace(/_/g, '.');
    }
    if (ua.match('Debian')) {
        name = 'Debian';
    }
    if (ua.match('Fedora')) {
        name = 'Fedora';
        const match = /Fedora\/[0-9.-]+fc([0-9]+)/.exec(ua);
        if (match)
            version = match[1];
    }
    if (ua.match('Red Hat')) {
        name = 'Red Hat';
        const match = /Red Hat[^/]*\/[0-9.-]+el([0-9_]+)/.exec(ua);
        if (match)
            version = match[1].replace(/_/g, '.');
    }
    if (ua.match('Ubuntu')) {
        name = 'Ubuntu';
        const match = /Ubuntu\/([0-9.]*)/.exec(ua);
        if (match)
            version = match[1];
    }
    return { name, version };
}
function getIOSInfo(ua) {
    let version = '1.0';
    if (/OS (.*) like Mac OS X/.test(ua)) {
        version = RegExp.$1.replace(/_/g, '.');
    }
    return { name: 'iOS', version };
}
function getMacOSXInfo(ua) {
    let version = '';
    if (/Mac OS X (10[0-9._]*)/.test(ua)) {
        version = RegExp.$1.replace(/_/g, '.');
    }
    return { name: 'Mac OS X', version };
}
function getAndroidInfo(ua) {
    let version = '';
    const _ua = ua.replace('-update', '.');
    if (/Android(?: )?(?:AllPhone_|CyanogenMod_)?(?:\/)?v?([0-9.]+)/.test(_ua)) {
        version = RegExp.$1;
    }
    return { name: 'Android', version };
}
function getWindowsInfo(ua) {
    let name = 'Windows';
    let version = '';
    let alias = '';
    if (/Windows NT ([0-9]+\.[0-9])/.test(ua)) {
        version = RegExp.$1;
        const map = {
            '5.0': '2000',
            '5.1': 'XP',
            '5.2': 'Server 2003',
            '6.0': 'Vista',
            '6.1': '7',
            '6.2': '8',
            '6.3': '8.1',
            '6.4': '10技术预览版',
            '10': '10',
            '10.0': '10',
        };
        alias = map[version] || 'NT ' + parseVersion(version);
    }
    if (ua.match('Windows XP') || ua.match('WinXP')) {
        version = '5.1';
        alias = 'XP';
    }
    if (ua.match('WP7')) {
        name = 'Windows Phone';
        version = '7.0';
    }
    if (/WindowsMobile\/([0-9.]*)/.test(ua)) {
        name = 'Windows Mobile';
        version = RegExp.$1;
    }
    if (/Windows Phone ([0-9.]*)/.test(ua)) {
        name = 'Windows Mobile';
        version = RegExp.$1;
    }
    if (/Windows Phone OS ([0-9.]*)/.test(ua)) {
        name = 'Windows Phone';
        version = RegExp.$1;
        if (+version < 7) {
            name = 'Windows Mobile';
        }
    }
    return { name, version, alias };
}
/**
 * 获取操作系统平台信息
 * @param {string} ua User-Agent
 * @returns {{ name: string, version: string, alias?: string }}
 */
function getOSInfo(ua) {
    const os = {
        name: '',
        version: '',
        isAndroid: false,
        isIOS: false,
        isMobile: false,
        isPC: false,
        isMac: false,
        isWindows: false,
        isLinux: false,
    };
    os.isMobile = isMobileByUserAgent(ua);
    os.isPC = !os.isMobile;
    if (ua.match('Unix')) {
        os.name = 'Unix';
        return os;
    }
    if (ua.match('FreeBSD')) {
        os.name = 'FreeBSD';
        return os;
    }
    if (ua.match('Android')) {
        os.isAndroid = true;
        os.isMobile = true;
        os.isPC = false;
        return { ...os, ...getAndroidInfo(ua) };
    }
    if (ua.match('iPhone( Simulator)?;') ||
        ua.match('iPad;') ||
        ua.match('iPod;') ||
        ua.match(/iPhone\s*[\d,]*s?[cp]?;/i)) {
        os.isIOS = true;
        os.isMobile = true;
        os.isPC = false;
        return { ...os, ...getIOSInfo(ua) };
    }
    if (ua.match('Mac OS X')) {
        os.isMac = true;
        return { ...os, ...getMacOSXInfo(ua) };
    }
    if (ua.match('Linux')) {
        os.isLinux = true;
        return { ...os, ...getLinuxInfo(ua) };
    }
    if (ua.match('Windows')) {
        os.isWindows = true;
        return { ...os, ...getWindowsInfo(ua) };
    }
    if (ua.match('CrOS')) {
        return { ...os, name: 'Chrome OS' };
    }
    return os;
}
function getChromiumInfo(ua) {
    let version = '';
    if (/Chromium\/([0-9.]*)/.test(ua))
        version = RegExp.$1;
    return { name: 'Chromium', version };
}
function getChromeInfo(ua) {
    let name = 'Chrome';
    let version = '';
    if (/(?:Chrome|CriOS)\/([0-9.]*)/.test(ua)) {
        version = RegExp.$1;
    }
    else if (/Version\/([0-9.]+) Mobile/.test(ua)) {
        name = 'Android';
        version = RegExp.$1;
    }
    return { name, version };
}
function getFirefoxInfo(ua) {
    let version = '';
    if (/(?:Firefox|FxiOS)\/([0-9ab.]*)/.test(ua))
        version = RegExp.$1;
    return { name: 'Firefox', version };
}
function getSafariInfo(ua) {
    let version = '';
    if (/Version\/([0-9.]+)/.test(ua))
        version = RegExp.$1;
    return { name: 'Safari', version };
}
function getIEInfo(ua) {
    let version = '';
    if (/MSIE ([0-9.]*)/.test(ua))
        version = RegExp.$1;
    return { name: 'IE', version };
}
function getEdgeInfo(ua) {
    let version = '';
    if (/Edge\/([0-9.]*)/.test(ua))
        version = RegExp.$1;
    return { name: 'Edge', version };
}
function getOperaInfo(ua) {
    let version = '';
    if (/Opera[/| ]([0-9.]*)/.test(ua))
        version = RegExp.$1;
    return { name: 'Opera', version };
}
// 检测各种乱七八糟的国产浏览器
function getChinaBrowserInfo(ua) {
    const browsers = [
        {
            name: 'QQ',
            detect: /M?QQBrowser\/([0-9.]*)/i,
        },
        {
            name: 'TT',
            detect: /TencentTraveler ([0-9.]*)/i,
        },
        {
            name: 'Weixin',
            detect: /MicroMessenger\/([0-9.]*)/i,
        },
        {
            name: 'Sogou',
            detect: /SE 2.X MetaSr/i,
        },
        {
            name: 'Liebao',
            detect: /LBBROWSER/i,
        },
        {
            name: 'Maxthon',
            detect: /Maxthon[/ ]([0-9.]*)/i,
        },
        {
            name: '360SE',
            detect: /360SE/i,
        },
        {
            name: '360EE',
            detect: /360EE/i,
        },
        {
            name: 'Baidu',
            detect: /(?:M?BaiduBrowser|BIDUBrowser|BaiduHD)\/([0-9.]*)/i,
        },
        {
            name: 'Taobao',
            detect: /TaoBrowser\/([0-9.]*)/i,
        },
    ];
    for (const browser of browsers) {
        if (browser.detect.test(ua)) {
            return { name: browser.name, version: RegExp.$1 || '' };
        }
    }
    if (ua.match('UCWEB') || ua.match('UCBrowser')) {
        let version = '';
        if (/UCWEB([0-9.]*)/.test(ua))
            version = RegExp.$1;
        if (/UCBrowser\/([0-9.]*)/.test(ua))
            version = RegExp.$1;
        return { name: 'UC', version };
    }
    return null;
}
/**
 * 获取浏览器信息
 * @param {string} ua User-Agent
 * @returns {{ name: string, version: string }}
 */
function getBrowserInfo(ua) {
    const browser = {
        name: '',
        version: '',
        isChrome: false,
        isEdge: false,
        isFirefox: false,
        isIE: false,
        isSafari: false,
    };
    // 最先检测各种国产魔改的壳浏览器
    const china = getChinaBrowserInfo(ua);
    if (china)
        return { ...browser, ...china };
    if (ua.match('MSIE')) {
        browser.isIE = true;
        return { ...browser, ...getIEInfo(ua) };
    }
    if (ua.match(/Firefox|FxiOS/)) {
        browser.isFirefox = true;
        return { ...browser, ...getFirefoxInfo(ua) };
    }
    if (ua.match(/Opera/i))
        return { ...browser, ...getOperaInfo(ua) };
    if (ua.match('Edge')) {
        browser.isEdge = true;
        return { ...browser, ...getEdgeInfo(ua) };
    }
    if (ua.match('Chromium'))
        return { ...browser, ...getChromiumInfo(ua) };
    if (ua.match(/Chrome|CriOS/) || ua.match('Android')) {
        browser.isChrome = true;
        return { ...browser, ...getChromeInfo(ua) };
    }
    if (ua.match('Safari')) {
        browser.isSafari = true;
        return { ...browser, ...getSafariInfo(ua) };
    }
    return browser;
}
/**
 * 获取浏览器内核引擎信息
 * @param {string} ua User-Agent
 * @returns {{ name: string, version: string }}
 */
function getEngineInfo(ua) {
    const engine = {
        name: '',
        version: '',
        isWebkit: false,
        isKHTML: false,
        isGecko: false,
        isPresto: false,
        isTrident: false,
    };
    if (/WebKit\/([0-9.]*)/i.test(ua) ||
        /Browser\/AppleWebKit([0-9.]*)/i.test(ua)) {
        engine.name = 'Webkit';
        engine.version = RegExp.$1;
        engine.isWebkit = true;
        return engine;
    }
    if (/KHTML\/([0-9.]*)/.test(ua)) {
        engine.name = 'KHTML';
        engine.version = RegExp.$1;
        engine.isKHTML = true;
        return engine;
    }
    if (/Gecko/.exec(ua) && !/like Gecko/i.test(ua)) {
        engine.name = 'Gecko';
        if (/; rv:([^)]+)\)/.test(ua))
            engine.version = RegExp.$1;
        engine.isGecko = true;
        return engine;
    }
    if (/Presto\/([0-9.]*)/.test(ua)) {
        engine.name = 'Presto';
        engine.version = RegExp.$1;
        engine.isPresto = true;
        return engine;
    }
    if (/Trident\/([0-9.]*)/.test(ua)) {
        engine.name = 'Trident';
        engine.version = RegExp.$1;
        engine.isTrident = true;
        return engine;
    }
    return engine;
}
/**
 * 获取App环境信息（仅移动端）
 * @param {string} ua User-Agent
 * @returns {{ name: string, version: string }}
 */
function getAppInfo(ua) {
    const app = {
        name: '',
        version: '',
        isWeixin: false,
        isWXWork: false,
    };
    // 生成所有APP来源及其版本信息的正则表达式
    const pattern = (function () {
        let p = '';
        const targetApp = ['MicroMessenger', 'Weibo', 'Qzone', 'QQ', 'NewsArticle'];
        const size = targetApp.length;
        for (let i = 0; i < size; i++) {
            if (0 === i) {
                p += targetApp[i];
            }
            else {
                p += '|' + targetApp[i];
            }
        }
        if (p) {
            p = '\\b' + '(' + p + ')' + '/[0-9.]*';
        }
        return new RegExp(p);
    })();
    // 分别获取APP来源和版本信息
    const match = ua.match(pattern);
    if (match) {
        const s = match[0].split('/');
        app.name = s[0];
        app.version = s[1];
    }
    if (app.name === 'MicroMessenger') {
        if (/wxwork\/([0-9.]*)/i.test(ua)) {
            // 企业微信
            app.name = 'wxwork';
            app.version = RegExp.$1;
            app.isWXWork = true;
        }
        else {
            app.name = 'Weixin';
            app.isWeixin = true;
        }
    }
    return app;
}
/**
 * 获取手机型号： 华为 小米 iphone6
 * @param {string} ua User-Agent
 */
function getDeviceModelInfo(ua) {
    const dInfo = ua.split(/[ ]\(|\)[ ]/)[1];
    let model = '', device = '';
    if (/iPhone/i.test(ua)) {
        device = 'iphone';
        model = 'iphone';
    }
    else if (/(iPad|iPod)/i.test(ua)) {
        device = 'ipad';
        model = 'ipad';
    }
    else if (/Android/i.test(ua)) {
        device = 'android';
        model = 'android';
    }
    const screenWidth = window.screen.width || 0;
    const screenHeight = window.screen.height || 0;
    const ratio = window.devicePixelRatio || 0;
    if ('android' === device) {
        // 设备品牌
        model = (function (md) {
            // 三星
            if (/GT-|SM-|SCH-/gi.test(md))
                return 'samsung';
            // 小米
            else if (/HM|RedMi|Mi|MIX/gi.test(md))
                return 'xiaomi';
            // 华为
            else if (/HUAWEI|HONOR/gi.test(md))
                return 'Huawei';
            // vivo
            else if (/vivo/gi.test(md))
                return 'vivo';
            // 美图
            else if (/Meitu|MP/gi.test(md))
                return 'Meitu';
            // OPPO
            else if (/OPPO|R6|R7|R8/gi.test(md))
                return 'OPPO';
            // 酷派
            else if (/Coolpad|SK1/gi.test(md))
                return 'Coolpad';
            // 华硕
            else if (/ASUS/gi.test(md))
                return 'ASUS';
            // 中兴
            else if (/ZTE/gi.test(md))
                return 'ZTE';
            // HTC
            else if (/HTC/gi.test(md))
                return 'HTC';
            // Sony
            else if (/Sony/gi.test(md))
                return 'Sony';
            // 联想
            else if (/Lenovo/gi.test(md))
                return 'Lenovo';
            // 努比亚
            else if (/NX5/gi.test(md))
                return 'nubia';
            // 锤子
            else if (/SM|YQ/gi.test(md))
                return 'Smartisan';
            // 魅族
            //不准确,会把其他的算进来
            else if (/m([0-9cx]{1,4})/gi.test(md) || /PRO 5/g.test(md))
                return 'meizu';
            else
                return 'UNKOWN';
        })(dInfo);
    }
    else if ('iphone' === device) {
        model = 'iphoneOther';
        if (screenWidth === 320) {
            if (screenHeight === 480) {
                if (ratio === 2) {
                    model = 'iphone4x';
                }
                else {
                    model = 'iphoneOther';
                }
            }
            if (screenHeight === 568) {
                model = 'iphone5x';
            }
        }
        if (screenWidth === 375) {
            if (screenHeight === 667) {
                model = 'iphone6x';
            }
            else if (screenHeight === 812) {
                model = 'iphoneX';
            }
        }
        if (screenWidth === 414) {
            model = 'iphone6xp';
        }
    }
    return model;
}
/**
 * 根据User-Agent获取相关信息
 * @param {string} [ua] User-Agent
 * @returns {DeviceInfo}
 */
export function getDeviceInfo(ua) {
    if (!ua)
        ua = window.navigator.userAgent;
    const info = {
        ua,
        os: getOSInfo(ua),
        browser: getBrowserInfo(ua),
        deviceModel: getDeviceModelInfo(ua),
        engine: getEngineInfo(ua),
        app: getAppInfo(ua),
    };
    return info;
}
/**
 * 全局的当前客户端信息
 * @type {DeviceInfo}
 */
export const globalDeviceInfo = getDeviceInfo(window.navigator.userAgent);
//# sourceMappingURL=device.js.map